import { collection, getDocs, Firestore, doc, getDoc, setDoc } from 'firebase/firestore'; 
import { auth } from '../../config/firebase';

// Define an interface for your user documents
export interface User {
  uid: string,
  email: string | null,
  displayName: string | null,
  isAdmin?: boolean,
  createdAt: Date
  // Add other fields as needed
}

export async function getUsersFromFirestore(db: Firestore): Promise<User[]> {
  const usersCollectionRef = collection(db, 'users');
  const snapshot = await getDocs(usersCollectionRef);
  
  const users: User[] = snapshot.docs.map(doc => {
    return { uid: doc.id, ...doc.data() } as User;
  });
  
  return users;
}

export async function validateUser(db: Firestore, uid: string) : Promise<User | null> {
    if (auth.currentUser !== null && auth.currentUser.uid === uid) {
      const userDocRef = doc(db, 'users', uid);
      const userDoc = await getDoc(userDocRef);
      if (!userDoc.exists()) {
        // First time user (no profile doc)
        const newUser : User = {
          uid: uid,
          email: auth.currentUser.email,
          createdAt: new Date(),
          displayName: auth.currentUser.displayName
        // ...other user profile fields
      }

        await setDoc(userDocRef, newUser)
        return newUser // ???
        // Perform first-time onboarding actions
      } else {
        return { uid: userDoc.id, ...userDoc.data() } as User
      }
    }
    return null;
  }

  export function formatNameToInitialLast(fullName: string): string {
    if (!fullName) return "";
  
    const parts = fullName.trim().split(/\s+/);
    if (parts.length === 0) return "";
  
    const firstInitial = parts[0].charAt(0).toUpperCase();
    const lastName = parts[parts.length - 1];
  
    return `${firstInitial}. ${lastName}`;
  }
